import { Box, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import React, {  } from "react";
import { NavLink } from "react-router-dom";
import ProductIcon from "legacy-components/icons/productIcon";

export const ProductNavigation: React.FC  = () => {
    return (
        <NavLink
                className="navigation-tab"
                key={"consumer-products"}
                activeClassName="active"
                to={'/home/consumer/products'}
            >
                <ListItem
                    button
                    >
                    <ListItemIcon>
                        <ProductIcon style={{ color: "#fff" }} />
                    </ListItemIcon>
                    <ListItemText
                        className="sub-menu-text"
                        primary={<Box display="flex"><Box flexGrow={1}>Products</Box>
                                </Box>}
                    />
                    </ListItem>
            </NavLink>
    );
}